/**
 * @desc model
 */
import Model from './baseModel';
export { default as SeriesModel, } from './seriesModel';
export { default as ComponentModel } from './componentModel';
export default Model;
export function renderModel(model) {
    var geom = model.render();
    if (geom) {
        geom && geom.setAttr('ref', model.groupRef);
    }
    else {
        model.groupRef.current = null;
    }
    return geom;
}
